type IconGithubProps = {
    className?: string;
};

export function IconGithub(props: IconGithubProps) {
    const { className = '' } = props;
    return (
        <svg
            aria-hidden={true}
            className={`${className}`}
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2525_2783)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.2135 0.703125C5.45975 0.703125 0 6.20312 0 13.0074C0 18.4464 3.49825 23.0504 8.35125 24.6799C8.958 24.8024 9.18025 24.4151 9.18025 24.0894C9.18025 23.8041 9.16025 22.8264 9.16025 21.8076C5.76275 22.5411 5.05525 20.3409 5.05525 20.3409C4.50925 18.9149 3.70025 18.5484 3.70025 18.5484C2.58825 17.7946 3.78125 17.7946 3.78125 17.7946C5.01475 17.8761 5.662 19.0576 5.662 19.0576C6.75375 20.9316 8.513 20.4021 9.22075 20.0761C9.32175 19.2816 9.6455 18.7316 9.98925 18.4261C7.2795 18.1409 4.4285 17.0816 4.4285 12.3554C4.4285 11.0109 4.9135 9.91088 5.682 9.05538C5.56075 8.74988 5.136 7.48663 5.8035 5.79588C5.8035 5.79588 6.83475 5.46988 9.16 7.05888C10.1555 6.78954 11.1822 6.65253 12.2135 6.65137C13.2448 6.65137 14.296 6.79413 15.2668 7.05888C17.5923 5.46988 18.6235 5.79588 18.6235 5.79588C19.291 7.48663 18.866 8.74988 18.7447 9.05538C19.5335 9.91088 19.9985 11.0109 19.9985 12.3554C19.9985 17.0816 17.1475 18.1204 14.4175 18.4261C14.8625 18.8131 15.2465 19.5464 15.2465 20.7076C15.2465 22.3576 15.2265 23.6819 15.2265 24.0891C15.2265 24.4151 15.449 24.8024 16.0555 24.6801C20.9085 23.0501 24.4067 18.4464 24.4067 13.0074C24.4268 6.20312 18.947 0.703125 12.2135 0.703125Z"
                    fill={'black'}
                />
            </g>
            <defs>
                <clipPath id="clip0_2525_2783">
                    <rect width="24.5" height="24" fill="white" transform="translate(0 0.703125)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconGithub;
